/**
 * Internal dependencies
 */
export type RemoveFolderClickDatalayerProps = {
	folderAmount: string;
	totalRecipeCount: string;
};

/**
 * Pushes an event to the data layer when the remove folder button is clicked.
 * This is used for analytics tracking.
 * @param {RemoveFolderClickDatalayerProps} props                  - The properties for the event.
 * @param {string}                          props.folderAmount     - The amount of folders.
 * @param {string}                          props.totalRecipeCount - The total number of recipes.
 * @return {void}
 */
export function pushRemoveFolderClick({
	folderAmount,
	totalRecipeCount,
}: RemoveFolderClickDatalayerProps): void {
	const isProduction = Boolean(window.valioAnalytics.isProduction);
	const datalayerObject = {
		event: 'remove_folder_click',
		folder_amount: folderAmount,
		total_recipe_count: totalRecipeCount,
	};

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(datalayerObject);

	if (!isProduction) {
		// eslint-disable-next-line no-console
		console.log('🔍 DataLayer: remove_folder_click', datalayerObject);
	}
}
